import React, { useState } from "react";
import { Table } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import NoData from "../NoData";

function GridModal({
  show,
  onHide = () => {},
  title,
  data = [],
  setSelected = { setSelected },
  selected = { selected },
  hasImage = true,
}) {
  function onSelect(item) {
    setSelected(item);
    setTimeout(() => {
      onHide();
    }, 500);
  }

  
  return (
    <Modal show={show} aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="grid-example">
        <Container>
        {data.length === 0 && <NoData />}
          {hasImage && (
            <Row>
              {data.map((item, key) => {
                return (
                  <Col xs={12} md={6} key={key}>
                    <div
                      onClick={() => onSelect(item)}
                      className={`image-container-brand ${
                        selected.id == item.id ? "border-if-selected" : ""
                      }`}
                    >
                      <img
                        src={item.image.uri}
                        alt="image"
                        className="image-brand"
                      />
                      <p>{item.title}</p>
                    </div>
                  </Col>
                );
              })}
            </Row>
          )}
          {!hasImage && (
            <Row>
              <Table striped bordered hover responsive>
                <tbody>
                  {data.map((item, key) => {
                    return (
                      <Row onClick={() => onSelect(item)}>
                        <tr>
                          <td>{key + 1}</td>
                          <td>{item.title}</td>
                        </tr>
                      </Row>
                    );
                  })}
                </tbody>
              </Table>
            </Row>
          )}
        </Container>
      </Modal.Body>
    </Modal>
  );
}

export default GridModal;

